module.exports = __webpack_public_path__ + "b73cce5c9f6767947029309798626824.MP3";